import { render, staticRenderFns } from "./PlatformList.vue?vue&type=template&id=252fb811"
import script from "./PlatformList.vue?vue&type=script&lang=js"
export * from "./PlatformList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports